import jwt from 'jsonwebtoken'
import moment from 'moment'
import { UUID } from '~/config'

/** @type {() => string} */
export const generateToken = () => jwt.sign({ date: moment().toISOString() }, UUID)
